import _get from 'lodash/get';

export const getRegistryAvatarUrl = state => _get(state, 'registry.profile_image');

export const getRegistryIsPublic = state => _get(state, 'registry.is_public');

export const getHasShippingAddress = state => _get(state, 'registry.has_shipping_address');

export const getRegistryKey = state => _get(state, 'registry.key');

export const getRegistryUrl = state => {
  const registryKey = getRegistryKey(state);

  if (!registryKey) return '';

  return `/registry/${registryKey}`;
};

export default { getRegistryAvatarUrl, getRegistryIsPublic, getRegistryKey, getRegistryPreviewUrl: getRegistryUrl }



// WEBPACK FOOTER //
// ./src/selectors/registry/registrySelectors.js